import React, { useState, useEffect } from 'react';
import { Form, Spin, notification, Button, Steps, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import CompanyInfoForm from './CompanyInfoForm';
import CompanyTargetForm from './CompanyTargetForm';
import useDocumentPageHook from '../DocumentPage/DocumentPageHook';
import './GettingStartedPage.css';

const { Step } = Steps;

const GettingStartedPage = () => {
  const [form] = Form.useForm();
  const { createBusinessContext, getBusinessContext } = useDocumentPageHook();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchAndSetBusinessContext() {
      setIsLoading(true);
      try {
        const response = await getBusinessContext();
        if (response) {
          navigate('/leads/campaign_setup')

        }
      } catch (error) {
        notification.error({
          message: 'Error',
          description: 'Failed to load existing information. Please try again.'
        });
      } finally {
        setIsLoading(false);
      }
    }
    fetchAndSetBusinessContext();
  }, []);

  const handleNext = (values) => {
    setFormData(prevData => ({ ...prevData, ...values }));
    setCurrentStep(currentStep + 1);
  };

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleSubmit = async (values) => {
    const finalFormData = new FormData();
  
    finalFormData.append('business_name', formData.businessName || '');
  
    if (formData.businessDescription) {
      finalFormData.append('business_description', formData.businessDescription);
    }
    if (formData.businessLinkedin) {
      finalFormData.append('business_linkedin_url', formData.businessLinkedin);
    }
    if (formData.businessCompanyUrl) {
      finalFormData.append('business_company_url', formData.businessCompanyUrl);
    }

    const keyQuestions = [
      {
        question: values.keyQuestion1,
        research_instruction: values.researchInstruction1 || ""
      },
      {
        question: values.keyQuestion2,
        research_instruction: values.researchInstruction2 || ""
      },
      {
        question: values.keyQuestion3,
        research_instruction: values.researchInstruction3 || ""
      }
    ];    


    const target_companies_info = {
      companySize: values.targetSize,
      location: values.location,
      industry: values.industry,
      customerPainPoints: values.customerPainPoints,
      valueProposition: values.customerValue,
      contact_preferences: values.contactPreference,
      additional_instruction: values.additionalInstruction,
      key_questions: keyQuestions,
    };    

    const icp = {}
    icp.target_companies_info = target_companies_info    

  
    finalFormData.append('icp', JSON.stringify(icp));
  
    setIsLoading(true);
    try {
      // Uncomment this line when ready to use
      await createBusinessContext(finalFormData);
      navigate('/leads/campaign_setup');
    } catch (error) {
      console.error('Failed to create business context:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleValidationError = (errorInfo) => {
    if (errorInfo.errorFields && errorInfo.errorFields.length > 0) {
      const errorMessage = errorInfo.errorFields.map(field => `${field.errors[0]}`).join(', ');
      message.error(errorMessage);
    } else {
      console.log(errorInfo)
      message.error('submission failed');
    }
  };  
  



  const steps = [
    {
      title: 'Company Info',
      content: <CompanyInfoForm form={form} />,
    },
    {
      title: 'Company TA Info',
      content: <CompanyTargetForm form={form} />,
    },
  ];

  return (
    <div className="getting-started-page">
      {isLoading ? (
        <Spin size="large" />
      ) : (
        <div style={{ 
          minWidth: '792px',
          margin: '0 auto', 
          padding: '22px 66px', 
          backgroundColor: '#fff', 
          borderRadius: '16px', 
          boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minHeight: '0'
        }}>
          <h1>Welcome to Dealight!</h1>
          <Steps current={currentStep} style={{padding: '20px'}}>
            {steps.map((item, index) => (
              <Step key={index} title={item.title} />
            ))}
          </Steps>
          <Form form={form} layout="vertical">
          <div className="steps-content">{steps[currentStep].content}</div>
          </Form>
          <div className="steps-action" style={{ textAlign: 'right', marginTop: 24 }}>
            {currentStep > 0 && (
              <Button style={{ marginRight: 8 }} onClick={handlePrevious}>
                Previous
              </Button>
            )}
            {currentStep < steps.length - 1 && (
              <Button type="primary" onClick={() => form.validateFields().then(handleNext).catch(handleValidationError)}>
                Next
              </Button>
            )}
            {currentStep === steps.length - 1 && (
              <Button type="primary" onClick={() => form.validateFields().then(handleSubmit).catch(handleValidationError)}>
                Submit
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GettingStartedPage;
